import {
  useEffect,
  useState
} from "react";

import {
  useNavigate,
  Link
} from "react-router-dom";

import {
  formatMoney
} from "../../utils/formatMoney";

import api from "../../api";

function PersonnelList() {

  const [data, setData] =
    useState([]);

  const navigate =
    useNavigate();

  // =====================
  // FETCH
  // =====================

  useEffect(() => {

    api
      .get("/personnel")
      .then((res) =>
        setData(
          res.data
        )
      )
      .catch((err) =>
        console.error(err)
      );

  }, []);

  // =====================
  // DELETE
  // =====================

  const supprimer =
    async (id) => {

      if (
        !window.confirm(
          "Confirmer suppression ?"
        )
      ) {
        return;
      }

      try {

        await api.delete(
          `/personnel/${id}`
        );

        setData(
          (prev) =>
            prev.filter(
              (p) =>
                p.id !== id
            )
        );

      } catch (err) {

        console.error(err);

        alert(
          "Erreur suppression"
        );

      }
    };

  // =====================
  // RENDER
  // =====================

  return (
    <div className="p-3 md:p-6 space-y-5 min-h-[100dvh] bg-gray-100">

      {/* HEADER */}
      <div className="flex flex-col md:flex-row justify-between md:items-center gap-3">

        <div className="flex flex-col md:flex-row md:items-center gap-3">

          <button
            onClick={() =>
              navigate(-1)
            }
            className="bg-gray-300 hover:bg-gray-400 transition px-4 py-3 rounded-xl"
          >
            ← Retour
          </button>

          <h2 className="text-2xl md:text-3xl font-semibold">
            Personnel
          </h2>

        </div>

        <Link
          to="/salaires"
          className="bg-indigo-600 hover:bg-indigo-700 transition text-white px-4 py-3 rounded-xl text-center"
        >
          💰 Voir salaires
        </Link>

      </div>

      {/* MOBILE */}
      <div className="grid gap-3 md:hidden">

        {data.map((p) => (

          <div
            key={p.id}
            className="bg-white rounded-2xl shadow p-4"
          >

            <div
              className="cursor-pointer"
              onClick={() =>
                navigate(
                  `/personnel/${p.id}`
                )
              }
            >

              <p className="font-semibold text-blue-600 text-lg">
                {p.nom}{" "}
                {
                  p.prenom
                }
              </p>

              <p className="text-sm text-gray-600 mt-1">
                {
                  p.fonction
                }
              </p>

              <p className="text-green-600 font-bold mt-2">
                {formatMoney(
                  p.salaire_base
                )}
              </p>

            </div>

            <div className="flex gap-2 mt-4">

              <button
                onClick={() =>
                  navigate(
                    `/personnel/${p.id}/edit`
                  )
                }
                className="flex-1 bg-blue-500 hover:bg-blue-600 transition text-white py-2 rounded-xl"
              >
                Modifier
              </button>

              <button
                onClick={() =>
                  supprimer(
                    p.id
                  )
                }
                className="flex-1 bg-red-500 hover:bg-red-600 transition text-white py-2 rounded-xl"
              >
                Supprimer
              </button>

            </div>

          </div>

        ))}

      </div>

      {/* DESKTOP */}
      <div className="hidden md:block bg-white rounded-2xl shadow overflow-x-auto">

        <table className="min-w-full text-sm">

          <thead className="bg-gray-900 text-white">

            <tr>

              <th className="px-4 py-3 text-left">
                Nom
              </th>

              <th className="px-4 py-3 text-left">
                Fonction
              </th>

              <th className="px-4 py-3 text-left">
                Salaire
              </th>

              <th className="px-4 py-3 text-left">
                Actions
              </th>

            </tr>

          </thead>

          <tbody>

            {data.map(
              (p) => (

                <tr
                  key={p.id}
                  className="border-t hover:bg-gray-50 transition"
                >

                  <td
                    className="px-4 py-3 cursor-pointer text-blue-600 font-medium hover:underline"
                    onClick={() =>
                      navigate(
                        `/personnel/${p.id}`
                      )
                    }
                  >
                    {p.nom}{" "}
                    {
                      p.prenom
                    }
                  </td>

                  <td className="px-4 py-3">
                    {
                      p.fonction
                    }
                  </td>

                  <td className="px-4 py-3 font-semibold text-green-600">
                    {formatMoney(
                      p.salaire_base
                    )}
                  </td>

                  <td className="px-4 py-3">

                    <div className="flex gap-2">

                      <button
                        onClick={() =>
                          navigate(
                            `/personnel/${p.id}/edit`
                          )
                        }
                        className="bg-blue-500 hover:bg-blue-600 transition text-white px-4 py-2 rounded-xl"
                      >
                        Modifier
                      </button>

                      <button
                        onClick={() =>
                          supprimer(
                            p.id
                          )
                        }
                        className="bg-red-500 hover:bg-red-600 transition text-white px-4 py-2 rounded-xl"
                      >
                        Supprimer
                      </button>

                    </div>

                  </td>

                </tr>

              )
            )}

          </tbody>

        </table>

      </div>

      {/* ACTION */}
      <div className="flex justify-end">

        <button
          onClick={() =>
            navigate(
              "/personnel/new"
            )
          }
          className="bg-green-600 hover:bg-green-700 transition text-white px-5 py-3 rounded-xl"
        >
          + Ajouter
        </button>

      </div>

    </div>
  );
}

export default PersonnelList;